import { CURRENCIES } from './currency-schema';

export const DEFAULT_CURRENCY = CURRENCIES.Usd;